import config from './config';
import algoliasearch from "algoliasearch";
import { createNullCache } from '@algolia/cache-common';
import APIClient from "../api/APIClient";
import {SERVICE_WS} from "../api/servicesHanu";


const algoliaConfig = config.get('algolia');
const algoliaClient = algoliasearch(algoliaConfig.app_id, algoliaConfig.search_api_key, {
  responsesCache: createNullCache(),
});


const getAlgoliaIndexInstance = (indexName = "") => algoliaClient.initIndex(algoliaConfig.indices[indexName]);


function getRequest(
  endpoint,
  params = {},
  abortController = null,
  service = SERVICE_WS,
  serializeParams = true,
) {
  const requestConfig = { params };

  if (abortController && abortController instanceof AbortController) {
    requestConfig.signal = abortController.signal;
  }

  if (serializeParams) {
    requestConfig.paramsSerializer = { encode: (value) => encodeURIComponent(value) };
  }

  const api = new APIClient({ endpoint, requestConfig, service });

  return api.get();
}


function postRequest(endpoint, body = {}, service = SERVICE_WS) {
  const api = new APIClient({
    endpoint,
    data: body,
    requestConfig: { keepalive: true },
    service,
  });

  return api.post();
}


function postRequestFile(endpoint, formData, service = SERVICE_WS) {
  const requestConfig = {
    transformRequest: [(data, headers) => {
      delete headers['Content-Type'];
      delete headers['Accept'];
      return data;
    }],
  };
  const api = new APIClient({
    endpoint,
    data: formData,
    requestConfig,
    service
  });

  return api.post();
}

//todo refactor this to avoid duplicated code
function patchRequestFile(endpoint, formData, service = SERVICE_WS) {
  const requestConfig = {
    transformRequest: [(data, headers) => {
      delete headers['Content-Type'];
      delete headers['Accept'];
      return data;
    }],
  };
  const api = new APIClient({
    endpoint,
    data: formData,
    requestConfig,
    service
  });

  return api.patch();
}


function patchRequest(endpoint, body = {}, service = SERVICE_WS) {
  const api = new APIClient({ endpoint, data: body, service });

  return api.patch();
}

function deleteRequest(endpoint, body = {}, service = SERVICE_WS) {
  const api = new APIClient({ endpoint, data: {}, service });

  return api.delete();
}


function handleResponse(response) {
  console.log('[API] response OK.');
  console.log(response);

  if (response?.data?.error) {
    return Promise.reject(response.data.error);
  }

  return response.data;
}


function handleErrorResponse(error) {
  if (!error.response) {
    return Promise.reject(error.message);
  }

  console.log('[API] response is NOT OK.');
  console.log(error.response);

  return Promise.reject(error.response);
}


export {
  getAlgoliaIndexInstance,
  getRequest,
  postRequest,
  postRequestFile,
  patchRequestFile,
  patchRequest,
  deleteRequest,
  handleResponse,
  handleErrorResponse,
};
